import React from 'react';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import {Box} from "@mui/material";
import './aboutUs.css'
import AboutUsDetails from "../../components/AboutUs/AboutUsDetails";
import OurTeam from "../../components/OurTeam/OurTeam";

const AboutUs: React.FC = () => {
  return (
    <Box className={'aboutUs'}>
      <Header/>
        <Box className="ellipse11"></Box>
        <Box className="ellipse22"></Box>
        <Box className="linear"></Box>
        <Box className='hero-ourgame'></Box>
        <AboutUsDetails/>
        <OurTeam/>
      <Footer/>
    </Box>
  );
};

export default AboutUs;